<template>
    <div class="bottomRight">
        <transition name="pop-up" appear mode="out-in">
            <div
                v-if="shouldShow"
                class="circular primary clickable"
                @click="handleClick"
            >
                <BaseIcon class="icon" name="arrow-up" />
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'ScrollToTop',
    data() {
        return {
            win: null,
            scrollDistance: 0,
            threshold: 500,
        };
    },
    computed: {
        hasCallback() {
            return this.$interfaces.floatingActionButton.shouldShow();
        },
        isScrolled() {
            return this.scrollDistance > this.threshold;
        },
        shouldShow() {
            return this.hasCallback && this.isScrolled;
        },
    },
    methods: {
        handleClick() {
            if (this.hasCallback) {
                this.$interfaces.floatingActionButton.callback();
            }
        },
        handleScroll(event) {
            this.scrollDistance = window.scrollY;
        },
    },
    created() {
        this.win = window;
        this.win.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        this.win.removeEventListener('scroll', this.handleScroll);
    },
};
</script>

<style lang="css" scoped>
.icon {
    font-size: 30px;
    color: white;
}
.circular {
    font-size: 100%;
    display: flex;
    justify-content: center;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06), 0 2px 3px rgba(0, 0, 0, 0.11);
}
.bottomRight {
    position: fixed;
    right: 25px;
    bottom: 100px;
}
</style>
